import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { formatPhoneNumber } from "lib/utils";
import Icon from "../icons";

const BusinessDetails = styled.ul`
  padding: 0;
`;

const BusinessDetail = styled.li`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: left;
  line-height: 1.25;
`;

const IconWrapper = styled(Icon)`
  fill: ${({ theme }) => theme.themeColors.darkGreen1};
  min-height: 20px;
  min-width: 20px;
`;

const Paragraph = styled.p`
  font-size: 16px;
  font-weight: 400;
  margin: 0 0 0 12px;
  word-break: break-word;
  white-space: pre-wrap;
`;

const Address = styled.div`
  margin: 0;
`;

const Link = styled.a`
  color: ${({ theme }) => theme.themeColors.primary};
  font-weight: 600;
  font-size: 14px;
  line-height: 1.25;
  margin: 0 0 4px 12px;
`;

const LinkWrapped = styled.a`
  color: ${({ theme }) => theme.themeColors.darkGreen1};
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.25;
  margin: 0;
  max-width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default function BusinessDetailLinks({ data }) {
  const { attributes } = data;
  const businessStreetAddress = attributes?.formattedAddress;
  const { phone, website, contactEmail } = attributes;
  const address = () => {
    if (businessStreetAddress) {
      return (
        <BusinessDetail>
          <IconWrapper name="location-20" />
          <div>
            <Address>
              <Paragraph>
                <LinkWrapped
                  href={`https://maps.google.com/?q=${businessStreetAddress}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {businessStreetAddress}
                </LinkWrapped>
              </Paragraph>
            </Address>
            <Link
              target="_blank"
              href={`https://maps.google.com/?q=${businessStreetAddress}`}
              rel="noopener noreferrer"
            >
              Get Directions
            </Link>
          </div>
        </BusinessDetail>
      );
    }
    return null;
  }
  return (
    <BusinessDetails>
      {address()}
      {phone && (
        <BusinessDetail>
          <IconWrapper name="phone-20" />
          <div>
            <Paragraph>
              <LinkWrapped
                href={`tel:${phone}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                {formatPhoneNumber(phone)}
              </LinkWrapped>
            </Paragraph>
            <Link
              href={`tel:${phone}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              Call Now
            </Link>
          </div>
        </BusinessDetail>
      )}
      {website && (
        <BusinessDetail>
          <IconWrapper name="website-20" />
          <div>
            <Paragraph>
              <LinkWrapped
                href={website}
                target="_blank"
                rel="noopener noreferrer"
              >
                {website}
              </LinkWrapped>
            </Paragraph>
            <Link href={website} rel="noopener noreferrer" target="_blank">
              Visit Website
            </Link>
          </div>
        </BusinessDetail>
      )}
      {contactEmail && (
        <BusinessDetail>
          <IconWrapper name="mail-20" />
          <div>
            <Paragraph>
              <LinkWrapped
                href={`mailto:${contactEmail}`}
                rel="noopener noreferrer"
              >
                {contactEmail}
              </LinkWrapped>
            </Paragraph>
            <Link href={`mailto:${contactEmail}`} rel="noopener noreferrer">
              Send an Email
            </Link>
          </div>
        </BusinessDetail>
      )}
    </BusinessDetails>
  );
}

BusinessDetailLinks.propTypes = {
  data: PropTypes.any.isRequired,
};
